<template>
  <div class="row" :style="diffStyle">
    <div>
      {{
        detail.material
          ? detail.material.model
            ? detail.material.model
            : detail.material.name
          : "错误"
      }}
    </div>
    <div>{{ (detail.ratio * 100).toFixed(3) }}%</div>
  </div>
</template>

<script>
export default {
  name: "MaterialRow",
  props: ["detail", "serachMaterial"],

  data() {
    return {};
  },
  computed: {
    diffStyle: function () {
      const style = {};
      if (this.serachMaterial && this.detail.material) {
        if (this.serachMaterial === this.detail.material._id) {
          style.backgroundColor = "#F5F598";
        }
      }
      return style;
    },
  },
};
</script>
<style lang="stylus" scoped>
.row
  display flex
  justify-content space-between
</style>